/* 🤖 this file was generated by svg-to-ts */
export const matIconPanoramaVerticalSelect: {
  name: 'panorama-vertical-select';
  data: string;
} = {
  name: 'panorama-vertical-select',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18.5 12c0-3.89.84-6.95 1.43-8.69A.993.993 0 0 0 18.98 2H5c-.68 0-1.16.66-.95 1.31C4.74 5.36 5.5 8.1 5.5 12c0 3.87-.76 6.66-1.45 8.69-.21.65.27 1.31.95 1.31h14c.68 0 1.17-.66.95-1.31-.68-2.03-1.45-4.83-1.45-8.69z"/></svg>`
};
